import { formatDateFromTimestamp } from "../../../utils/dateFormatter";

interface ProjectChatDateSeparatorProps {
  timestamp: number;
}

export default function ProjectChatDateSeparator({
  timestamp,
}: ProjectChatDateSeparatorProps) {
  const dateLabel = formatDateFromTimestamp(timestamp);

  return (
    <div className="flex items-center gap-5 py-4">
      <div className="flex-1 h-px bg-[#373B40]" />
      <span className="text-sm font-medium text-[#373B40]">{dateLabel}</span>
      <div className="flex-1 h-px bg-[#373B40]" />
    </div>
  );
}
